import { render, staticRenderFns } from "./main-navbar-tab.vue?vue&type=template&id=08b08941&scoped=true"
import script from "./main-navbar-tab.vue?vue&type=script&lang=js"
export * from "./main-navbar-tab.vue?vue&type=script&lang=js"
import style0 from "./main-navbar-tab.vue?vue&type=style&index=0&id=08b08941&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b08941",
  null
  
)

export default component.exports